import {
    Button,
    CircularProgress,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import MainCard from "ui-component/cards/MainCard";
import {
    IconEdit,
    IconListCheck,
    IconMessage,
    IconPasswordUser,
    IconShieldLock,
} from "@tabler/icons-react";
import { useTheme } from "@mui/system";
import SubCard from "ui-component/cards/SubCard";
import { useParams } from "react-router-dom";
import {
    closeUserEditDialog,
    getUserDetails,
    openUserEditDialog,
    resetUserPassword,
    resetUserPasswordErrorClear
} from "store/app/user-management/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import EditUser from "./edit";
import Chip from "ui-component/extended/Chip";
import { IconMap2 } from "@tabler/icons-react";

const UserDetails = (props) => {
    const { userDetails, errorMessage, isPending, resetPasswordErrorMessage, isResetPasswordPending, isUserEditDialogOpen, userProfile } = props;
    const { displayName, email, firstName, isActive, isEnabled, lastName, mobileNumber } = userDetails || {};
    const { userRegions, userStates } = userDetails || [];
    const { userRoleName } = userProfile || {};
    const params = useParams();
    const { id } = params || {};

    useEffect(() => {
        props.getUserDetails(id);
        props.resetUserPasswordErrorClear();
    }, [id])

    const theme = useTheme();

    const resetUserPassword = () => {
        props.resetPassword(email);
    }

    const handleUserEditOpen = () => {
        props.openUserEditDialog();
    }

    const handleUserEditClose = () => {
        props.closeUserEditDialog();
    }

    return (
        <>
            <Grid container>
                <Grid item md={12} sm={12} xs={12}>
                    <SubCard sx={{ p: 1.5, pl: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h4">User Details</Typography>
                        {(!errorMessage && (userRoleName === "Administrator" || userRoleName === "Master admin")) &&
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleUserEditOpen}
                                startIcon={<IconEdit />}
                            >
                                Edit User
                            </Button>}
                    </SubCard>
                </Grid>
                {errorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={errorMessage} />
                    </Grid>
                }
                {resetPasswordErrorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={`Reset Password: ${resetPasswordErrorMessage}`} />
                    </Grid>
                }
            </Grid>
            {isPending ?
                <Grid container alignItems={"center"} justifyContent={"center"} gap={1}>
                    <CircularProgress />
                    <Typography variant="h5" color={'primary'}> Loading...</Typography>
                </Grid>
                :
                <Grid container columnSpacing={1}>
                    <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
                            <MainCard sx={{ mt: 1 }}>
                                <Grid container gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <IconListCheck color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Basic Info
                                    </Typography>
                                </Grid>
                                <TableContainer sx={{ pl: 3, mt: 1, mb: 1 }}>
                                    <Table size="small">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>First Name</TableCell>
                                                <TableCell>{firstName || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Last Name</TableCell>
                                                <TableCell>{lastName || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Display Name</TableCell>
                                                <TableCell>{displayName || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Role</TableCell>
                                                <TableCell>{userDetails?.userRoleName || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>User Status</TableCell>
                                                <TableCell>
                                                    {isActive ?
                                                        <Chip label={"Active"} chipcolor="success" size="small" />
                                                        : <Chip label={"Inactive"} chipcolor="error" size="small" />
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Account Status</TableCell>
                                                <TableCell>
                                                    {isEnabled ?
                                                        <Chip label={"Enabled"} chipcolor="success" size="small" />
                                                        : <Chip label={"Disabled"} chipcolor="error" size="small" />
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </MainCard>
                        </Grid>
                        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
                            <MainCard sx={{ mt: 1 }}>
                                <Grid container alignItems={'center'} gap={1}>
                                    <IconMessage color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Communication Info
                                    </Typography>
                                </Grid>
                                <TableContainer sx={{ pl: 3, mt: 1 }}>
                                    <Table size="small">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>Email Address</TableCell>
                                                <TableCell>{email || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Mobile Number</TableCell>
                                                <TableCell>{mobileNumber || "N/A"}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </MainCard>
                        </Grid>
                    </Grid >
                    <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
                            {(userRoleName === "Administrator" || userRoleName === "Master admin") &&
                                <Grid item>
                                    <MainCard sx={{ mt: 1 }}>
                                        <Grid container alignItems={'center'} gap={1}>
                                            <IconShieldLock color={theme.palette.secondary.dark} />
                                            <Typography variant="h4" color={theme.palette.primary.dark}>
                                                Reset Password
                                            </Typography>
                                        </Grid>
                                        <Grid container sx={{ pl: 4, mt: 1 }} direction={'column'}>
                                            <Grid item>
                                                <Typography paragraph>
                                                    Here you can reset others password.
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={resetUserPassword}
                                                    startIcon={<IconPasswordUser />}
                                                    disabled={isResetPasswordPending}
                                                >
                                                    {isResetPasswordPending ?
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <CircularProgress size={'20px'} color='inherit' />
                                                            Loading...
                                                        </div>
                                                        :
                                                        <> Reset Password</>
                                                    }
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </MainCard>
                                </Grid>
                            }
                        </Grid>
                        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
                            <MainCard sx={{ mt: 1 }}>
                                <Grid container alignItems={'center'} gap={1}>
                                    <IconMap2 color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Assigned  Regions Info
                                    </Typography>
                                </Grid>
                                {
                                    userDetails?.userRoleName !== "User" ?
                                        <Grid container sx={{ mt: 2 }}>
                                            <Typography variant="caption" sx={{ fontSize: "13px" }}>
                                                All regions are assigned automatically for this user.
                                            </Typography>
                                        </Grid>
                                        :
                                        userRegions?.length > 0 ?
                                            <Grid item sx={{ mt: 2, mb: 2, display: "flex", gap: "5px", overflow: "auto", flexWrap: "wrap", rowGap: "10px" }}>
                                                {userRegions?.map((region, idx) => (
                                                    <Chip
                                                        key={idx}
                                                        chipcolor="orange"
                                                        label={
                                                            <Typography variant="h5" color="inherit">
                                                                {region.regionName}
                                                            </Typography>
                                                        }
                                                    />
                                                ))}
                                            </Grid>
                                            :
                                            <Grid container sx={{ mt: 2 }}>
                                                <Typography variant="caption" sx={{ fontSize: "13px" }}>
                                                    No region assigned to this user.
                                                </Typography>
                                            </Grid>
                                }
                            </MainCard>
                        </Grid>
                        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
                            <MainCard sx={{ mt: 1 }}>
                                <Grid container alignItems={'center'} gap={1}>
                                    <IconMap2 color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Assigned  States/Exports Info
                                    </Typography>
                                </Grid>
                                {
                                    userDetails?.userRoleName !== "User" ?
                                        <Grid container sx={{ mt: 2 }}>
                                            <Typography variant="caption" sx={{ fontSize: "13px" }}>
                                                All states/exports are assigned automatically for this user.
                                            </Typography>
                                        </Grid>
                                        :
                                        userStates?.length > 0 ?
                                            <Grid item sx={{ mt: 2, mb: 2, display: "flex", gap: "5px", overflow: "auto", flexWrap: "wrap", rowGap: "10px" }}>
                                                {userStates?.map((state, idx) => (
                                                    <Chip
                                                        key={idx}
                                                        chipcolor="orange"
                                                        label={
                                                            <Typography variant="h5" color="inherit">
                                                                {state.stateName}
                                                            </Typography>
                                                        }
                                                    />
                                                ))}
                                            </Grid>
                                            :
                                            <Grid container sx={{ mt: 2 }}>
                                                <Typography variant="caption" sx={{ fontSize: "13px" }}>
                                                    No state/export assigned to this user.
                                                </Typography>
                                            </Grid>
                                }
                            </MainCard>
                        </Grid>
                    </Grid >
                </Grid >
            }

            <EditUser open={isUserEditDialogOpen} onClose={handleUserEditClose} userDetails={userDetails} />
        </>
    )
}

const mapStateToProps = (state) => ({
    userDetails: state.users.userDetails,
    isPending: state.users.isUserDetailsPending,
    errorMessage: state.users.userDetailsErrorMessage,
    isResetPasswordPending: state.users.isResetUserPasswordPending,
    resetPasswordErrorMessage: state.users.resetUserPasswordErrorMessage,
    isUserEditDialogOpen: state.users.isUserEditDialogOpen,
    userProfile: state.login.userProfile,
})

const mapDispatchToProps = (dispatch) => ({
    getUserDetails: (id) => dispatch(getUserDetails(id)),
    resetPassword: (email) => dispatch(resetUserPassword(email)),
    resetUserPasswordErrorClear: () => dispatch(resetUserPasswordErrorClear()),
    openUserEditDialog: () => dispatch(openUserEditDialog()),
    closeUserEditDialog: () => dispatch(closeUserEditDialog()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);